import { render, staticRenderFns } from "./SideNavSedapar.vue?vue&type=template&id=0897ab26"
import script from "./SideNavSedapar.vue?vue&type=script&lang=js"
export * from "./SideNavSedapar.vue?vue&type=script&lang=js"
import style0 from "./SideNavSedapar.vue?vue&type=style&index=0&id=0897ab26&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports